import { connect, MapDispatchToProps } from 'react-redux';
import { removeAttachment } from '@wix/da-shared-react/pkg/redux/uploads/actions';
import { Props } from './AdditionalImagesPopup';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'removeAttachment'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  removeAttachment: (fileId, deviationId, onSuccess) =>
    dispatch(
      removeAttachment(fileId, deviationId, 'additional_image', onSuccess)
    ),
});

export default connect(null, mapDispatchToProps);
